module.exports = ".fullScreenActive {\r\n    color: #fff !important;\r\n    background-color: #00a0ea;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app_manager/app_element/status/status.component.css
// module id = ./src/app/app_manager/app_element/status/status.component.css
// module chunks = main